import { render, staticRenderFns } from "./Refund_detail.vue?vue&type=template&id=ba60ce7a&scoped=true&"
import script from "./Refund_detail.vue?vue&type=script&lang=js&"
export * from "./Refund_detail.vue?vue&type=script&lang=js&"
import style0 from "./Refund_detail.vue?vue&type=style&index=0&id=ba60ce7a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba60ce7a",
  null
  
)

export default component.exports